import styled from "styled-components";
import { Link } from "react-router-dom";

export const ServiceOuterContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	margin: 3rem 1rem 0rem 1rem;

	@media screen and (min-width: 768px) {
		margin: 3rem 2rem 5rem 2rem;
	}
`;

export const ServiceContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;

	@media screen and (min-width: 768px) {
		flex-direction: row;
	}

	@media screen and (min-width: 1024px) {
		flex-direction: row;
	}
`;


export const ServiceIntroContainer = styled.div`
	display: flex;
	flex-direction: column;
	margin: 0 0 3rem 0;
	padding: 12px;
	max-width: 410px;

	@media screen and (min-width: 768px) {
		padding: 24px 0 24px 24px;
		margin: 0 0 0.5rem 0;
		min-width: 360px;
		max-width: 490px;
	}

	@media screen and (min-width: 1024px) {
		padding: 40px 34px;
		margin: 10px 0 0 0;
	}
`;

export const Divider = styled.div`
	width: 100%;
	background-color: var(--maindark);
	height: 1.6px;
	margin: 0 0 2rem 0;

	@media screen and (min-width: 768px) {
		width: 1.6px;
		height: 820px;
		margin: 18px 0rem;
	}
`;

export const DividerHori = styled.div`
	width: 0px;
	background-color: var(--maindark);
	height: 1.6px;
	margin: 0;

	@media screen and (min-width: 768px) {
		width: 100%;
		background-color: var(--maindark);
		height: 1.6px;
		margin:0;
	}
`;

export const LongArrow = styled.img`
	display: none;

	@media screen and (min-width: 768px) {
		display: block;
		width: 150px;
		margin: -8px 180px;
	}

	@media screen and (min-width: 1024px) {
		display: block;
		width: 150px;
		margin: 22px 190px;
	}
`;


export const ServiceHead2 = styled.h2`
	font-size: 26px;
	color: var(--maindark);
	font-weight: 500;
	letter-spacing: 1px;
	margin-bottom: 1rem;

	@media screen and (min-width: 768px) {
		font-size: 28px;
	}

	@media screen and (min-width: 1024px) {
		font-size: 32px;
	}
`;

// Service Item Props
interface ServiceItemProps {
	to: string;
}

//Web Development
export const ServiceTitleWeb = styled.h3`
	font-size: 26px;
	color: var(--maindark);
	font-weight: 500;
	letter-spacing: 1px;
	position: relative;
	width: fit-content;
	margin: 0 0 12px 0;

	&::after {
		content: "";
		position: absolute;
		width: 0;
		height: 5px;
		bottom: -2px;
		left: 0;
		background-color: var(--accent-pink);
		transform-origin: left;
		transition: width 0.5s ease;
		visibility: hidden;
	}

	@media screen and (min-width: 768px) {
		font-size: 28px;
	}

	@media screen and (min-width: 1024px) {
		font-size: 32px;
	}
`;


export const ServiceItemWeb = styled(Link)<ServiceItemProps>`
	display: flex;
	flex-direction: column;
	margin: 0 0 2rem 0;
	max-width: 410px;
	text-decoration: none;
	padding: 12px;
	cursor: pointer;
	transition: background-color 0.3s ease;

	&:hover {
		background-color: var(--contrastlight);
	}

	&:hover ${ServiceTitleWeb} {
		color: var(--darktext);
	}

	&:hover ${ServiceTitleWeb}::after {
		width: 100%;
		visibility: visible;
	}

	@media screen and (min-width: 768px) {
		padding: 40px 34px;
		margin: 10px 0 0 0;
		min-width: 360px;
		max-width: 490px;
	}
`;


//Consultant
export const ServiceTitleConsult = styled.h3`
	font-size: 26px;
	color: var(--maindark);
	font-weight: 500;
	letter-spacing: 1px;
	position: relative;
	width: fit-content;
	margin: 0 0 12px 0;

	&::after {
		content: "";
		position: absolute;
		width: 0;
		height: 5px;
		bottom: -2px;
		left: 0;
		background-color: var(--accent-turkoise);
		transform-origin: left;
		transition: width 0.5s ease;
		visibility: hidden;
	}

	@media screen and (min-width: 768px) {
		font-size: 28px;
	}

	@media screen and (min-width: 1024px) {
		font-size: 32px;
	}
`;


export const ServiceItemConsult = styled(Link)<ServiceItemProps>`
	display: flex;
	flex-direction: column;
	margin: 0 0 2rem 0;
	max-width: 410px;
	text-decoration: none;
	padding: 12px;
	cursor: pointer;
	transition: background-color 0.3s ease;

	&:hover {
		background-color: var(--contrastlight);
	}

	&:hover ${ServiceTitleConsult} {
		color: var(--darktext);
	}

	&:hover ${ServiceTitleConsult}::after {
		width: 100%;
		visibility: visible;
	}

	@media screen and (min-width: 768px) {
		padding: 40px 34px;
		margin: 0;
		min-width: 360px;
		max-width: 490px;
	}
`;


//Partner
export const ServiceTitlePartner = styled.h3`
	font-size: 26px;
	color: var(--maindark);
	font-weight: 500;
	letter-spacing: 1px;
	position: relative;
	width: fit-content;
	margin: 0 0 12px 0;

	&::after {
		content: "";
		position: absolute;
		width: 0;
		height: 5px;
		bottom: -2px;
		left: 0;
		background-color:#f9f900;
		transform-origin: left;
		transition: width 0.5s ease;
		visibility: hidden;
	}

	@media screen and (min-width: 768px) {
		font-size: 28px;
	}

	@media screen and (min-width: 1024px) {
		font-size: 32px;
	}
`;

export const ServiceItemPartner = styled(Link)<ServiceItemProps>`
	display: flex;
	flex-direction: column;
	margin: 0 0 2rem 0;
	max-width: 410px;
	text-decoration: none;
	padding: 12px;
	cursor: pointer;
	transition: background-color 0.3s ease;

	&:hover {
		background-color: var(--contrastlight);
	}

	&:hover ${ServiceTitlePartner} {
		color: var(--darktext);
	}

	&:hover ${ServiceTitlePartner}::after {
		width: 100%;
		visibility: visible;
	}

	@media screen and (min-width: 768px) {
		padding: 40px 34px;
		margin: 0;
		min-width: 360px;
		max-width: 490px;
	}
`;

// Skills and details
export const SkillDetails = styled.div`
	display: flex;
	margin-top: 1rem;
	align-items: flex-start;
	gap: 10px;
`;

export const SkillIcon = styled.img`
	width: 40px;
	margin: 0 10px;
`;

export const SkillsList = styled.ul`
	display: flex;
	flex-wrap: wrap;
	list-style: none;
	gap: 10px 20px;

	li {
		font-size: 14px;
		letter-spacing: 0.5px;
		font-weight: 600;
		color: #252525;
	}
`;
